import { isProd } from '@m/config/FeatureFlags';

const SESSION_KEY = 'qa_expressOnboarding';
const VALID_VALUES = ['treatment', 'control'] as const;
type OverrideValue = (typeof VALID_VALUES)[number];

function isOverrideValue(value: string | null): value is OverrideValue {
  return (VALID_VALUES as readonly string[]).includes(value ?? '');
}

/** Call once on app load to capture ?expressOnboarding=<value> into sessionStorage. */
export function captureQAOnboardingOverride(search: string): void {
  if (isProd) return;
  const value = new URLSearchParams(search).get('expressOnboarding');
  if (isOverrideValue(value)) {
    sessionStorage.setItem(SESSION_KEY, value);
  }
}

/** Returns the current or persisted QA override when not in production. */
export function getQAOnboardingOverride(search = ''): OverrideValue | null {
  if (isProd) return null;
  const queryOverride = new URLSearchParams(search).get('expressOnboarding');
  if (isOverrideValue(queryOverride)) return queryOverride;

  const stored = sessionStorage.getItem(SESSION_KEY);
  return isOverrideValue(stored) ? stored : null;
}
